import React from "react";
import MainToolbarDefault from "./MainToolbarDefault";
import MainToolbarBackgroundMode from "./MainToolbarBackgroundMode";
import MainToolbarBoxLayoutEditor from "./MainToolbarBoxLayoutEditor";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { Globals } from "@coreapp/CoreApp/Globals";
import { enumUIModes } from "@coreapp/constants";
import { IsBackgroundFile } from "@coreapp/utils/IsBackgroundFile";

const MainToolbar = () => {
  const ctx = useWSMgrContext();
  const wsMgr = ctx.wsMgr.state;

  const currentFilename = wsMgr?.GetFileName(true);
  const isBackground = currentFilename ? IsBackgroundFile(currentFilename) : false;

  let showDefault = false;
  let showBackground = false;
  let showBLE = false;
  if (Globals._uiConfig.InBoxLayoutEditorMode()) {
    showBLE = true;
  } else if (Globals._uiConfig.InBackgroundEditorMode() || isBackground) {
    showBackground = true;
  } else {
    switch (Globals._uiConfig.GetUIMode()) {
      case enumUIModes.boxlayouteditor:
        showBLE = true;
        break;
      default:
        showDefault = true;
    }
  }

  return (
    <nav className="mainToolBar" aria-label="main toolbar" role="toolbar">
      {showDefault && <MainToolbarDefault />}
      {showBackground && <MainToolbarBackgroundMode />}
      {showBLE && <MainToolbarBoxLayoutEditor />}
    </nav>
  );
};

export default MainToolbar;
